import { openDialog } from 'vue3-promise-dialog'

import Confirmation from '@/components/stormy/Confirmation.vue'
import AdressBook from '@/components/stormy/AdressBook.vue'
import AxiosError from '@/components/stormy/AxiosError.vue'
import ObuShelterListAddDomain from '@/modules/obu-shelter/ObuShelterListAddDomain.vue'
import MediaModal from '@/modules/obu-media/index.vue'
import ObuSettingsProfile from '@/modules/obu-settings/ObuSettingsProfile.vue'
import ObuSettingsPassword from '@/modules/obu-settings/ObuSettingsPassword.vue'
import ObuContactEdit from '@/modules/obu-contacts/ObuContactsEdit.vue'

import SearchBar from '@/layouts/_components/SearchBar.vue'

async function confirm (props) {
  return await openDialog(Confirmation, props)
}

async function modalForMedia (props) {
  const result = await openDialog(MediaModal, props)
  if (result === null) {
    return false
  }

  return result
}

async function openProfileDialog (props) {
  return await openDialog(ObuSettingsProfile, { open: true })
}

async function openContactEditor (props) {
  props.open = true
  const result = await openDialog(ObuContactEdit, props)
  return result
}

async function openSearchBar (props) {
  return await openDialog(SearchBar, { open: true })
}

async function openPasswordDialog (props) {
  return await openDialog(ObuSettingsPassword, { open: true })
}

async function gscAddDomain (props) {
  return await openDialog(ObuShelterListAddDomain, props)
}

async function showAxiosErrorDialog (props) {
  return await openDialog(AxiosError, props)
}

async function adressBook (props) {
  return await openDialog(AdressBook, props)
}

export { confirm, openContactEditor, openProfileDialog, openPasswordDialog, adressBook, openSearchBar, showAxiosErrorDialog, gscAddDomain, modalForMedia }
